__webpack_require__.p = "/lighting/";